import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import Error from '../../../common/ErrorMessage'
import MCElement from '../../../common/MCElement'

import '../configPageItem/ConfigPageItem.scss'
import './ConfigPageItemCustom.scss'
import ConfigPageCustomItemPreview from './ConfigPageCustomItemPreview'

const ConfigPageCustomItem = ({
  screenName,
  screenDesc,
  screenTitle,
  checked,
  handleCheck,
  thumbnail,
  needFileUpload,
  openImageBank,
  imgSelection,
}) => {
  const { t } = useTranslation()

  return (
    <div className='config-item'>
      <MCElement
        type='checkbox'
        isSelected={checked}
        clicked={() => handleCheck(screenTitle)}
      />

      <img
        src={thumbnail}
        alt={t('proShop.configCustomItem.thumbnailAlt', { screenTitle })}
        className='config-item-preview-img'
      />
      <div>
        <h3 className='config-item-label'>{screenName}</h3>
        <p className='config-item-desc'>{screenDesc}</p>
        <div className='config-item-image-array'>
          <ConfigPageCustomItemPreview />
          <button onClick={openImageBank} className='no-bg-text-btn'>
            {imgSelection.length > 0
              ? t('proShop.configCustomItem.editSelection')
              : t('proShop.configCustomItem.chooseImages')}
          </button>
        </div>
        {checked && needFileUpload ? (
          <div className='config-item-error-msg'>
            <Error error={t('proShop.configCustomItem.pleaseChoose')} />
          </div>
        ) : null}
      </div>
    </div>
  )
}

ConfigPageCustomItem.propTypes = {
  checked: PropTypes.bool,
  needFileUpload: PropTypes.bool,
  imgSelection: PropTypes.array,
  screenName: PropTypes.string,
  screenTitle: PropTypes.string,
  screenDesc: PropTypes.string,
  thumbnail: PropTypes.string,
  openImageBank: PropTypes.func,
  handleCheck: PropTypes.func,
}

export default ConfigPageCustomItem
